/**
 * 사용자 접근 로그를 서버에 기록합니다. (fire-and-forget)
 * @param {{ user: string, email: string, brd_cd: string, page_nm: string, detail?: string }} payload
 */
export const logAccess = (payload) => {
  fetch('/api/user/log', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).catch(() => {});
};
